import { render, staticRenderFns } from "./courseEditTimeline.vue?vue&type=template&id=0636fb47&scoped=true"
import script from "./courseEditTimeline.vue?vue&type=script&lang=js"
export * from "./courseEditTimeline.vue?vue&type=script&lang=js"
import style0 from "./courseEditTimeline.vue?vue&type=style&index=0&id=0636fb47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636fb47",
  null
  
)

export default component.exports